module.exports = __webpack_public_path__ + "static/media/vericastlogoRETAILPORTALa.fb2314e7.png";